// The prototype used three.js r128: no colour management, linear output, and "legacy" lights
// (no 1/PI in the BRDF, linear point-light falloff). Modern three.js changed all three.
// This module restores the r128 look so the port renders like the prototype.
//
// - Colour management off + linear output: hex colours and canvas textures are used as-is.
// - Light intensities: modern lights are PI times dimmer for the same number, so scale by PI (LEGACY_LIGHT_SCALE).
// - Point light falloff: patch the shader chunk back to r128's non-physical formula.

import * as THREE from 'three';

THREE.ColorManagement.enabled = false;

export const LEGACY_LIGHT_SCALE = Math.PI;

const LEGACY_ATTENUATION = `float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	// three.js r128 non-physical falloff (restored by src/render/legacyLook.ts)
	if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {
		return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );
	}
	return 1.0;
}`;

const chunks = THREE.ShaderChunk as unknown as Record<string, string>;
const re = /float getDistanceAttenuation\([\s\S]*?return distanceFalloff;\s*\}/;
if (re.test(chunks.lights_pars_begin)) {
  chunks.lights_pars_begin = chunks.lights_pars_begin.replace(re, LEGACY_ATTENUATION);
} else {
  console.warn('legacyLook: could not patch point light falloff; the knife lighting will differ slightly');
}

export function configureLegacyRenderer(renderer: THREE.WebGLRenderer) {
  renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
  renderer.toneMapping = THREE.NoToneMapping;
}

/** r128 PointLight: intensity as given, linear falloff to `distance`. */
export function legacyPointLight(color: number, intensity: number, distance: number) {
  return new THREE.PointLight(color, intensity * LEGACY_LIGHT_SCALE, distance, 1);
}
